import React, { useEffect, useState } from 'react'

// Services
import { getTranslateByKey } from '@/main/services/utils';

// Components
import Box from '@/main/components/shared/box';
import KogInputText from '@/main/components/shared/inputText/inputText';

// Styles
import * as S from './styles'
import { partCatalogApi } from '@/main/api';
import { PartCatalogDetailRequest } from '@/main/models/request';
import { PartCatalogDetailResponse } from '@/main/models/response/partCatalogResponse';
import ColumnLabel from '@/main/components/common/columnLabel/columnLabel';
import LoadingComponent from '@/main/components/shared/loading/loadingComponent';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';

interface IModalPartsCatalogDetails {
  guidPartCodeMaster: string | null;
  closeModal: () => void;
}

function ModalPartsCatalogDetails({
  guidPartCodeMaster,
  closeModal
}: IModalPartsCatalogDetails) {

  const [isLoadingDetail, setIsLoadingDetail] = useState<boolean>(false)
  const [partCatalogDetail, setPartCatalogDetail] = useState<PartCatalogDetailResponse | null>(null)

  useEffect(() => {
    if (guidPartCodeMaster) {
      const request: PartCatalogDetailRequest = {
        guidPartCodeMaster
      }
      setIsLoadingDetail(true)
      partCatalogApi.detail(request)
        .then((res) => {
          const resData = res.data.result;
          setPartCatalogDetail(resData)
        })
        .catch(() => { })
        .finally(() => {
          setIsLoadingDetail(false)
        })
    }
  }, [guidPartCodeMaster])

  if (isLoadingDetail) return <LoadingComponent />;
  return (
    <>
      <Box>
        <S.AreaForm>
          <KogInputText
            id="id-partsCatalogModal-txt-country"
            name="country"
            label={getTranslateByKey('information.country')}
            value={partCatalogDetail?.country}
            InputLabelProps={{ shrink: true }}
            InputProps={{ readOnly: true }}
            errorMessageCustom={null}
          />
          <KogInputText
            id="id-partsCatalogModal-txt-partnumber"
            name="partNumber"
            label={getTranslateByKey('information.partnumber')}
            errorMessageCustom={null}
            value={partCatalogDetail?.partNumber}
            InputLabelProps={{ shrink: true }}
            InputProps={{ readOnly: true }}
          />
          <KogInputText
            id="id-partsCatalogModal-txt-partType"
            name="partType"
            label={getTranslateByKey('information.partTypes')}
            value={partCatalogDetail?.partType}
            InputLabelProps={{ shrink: true }}
            InputProps={{ readOnly: true }}
            errorMessageCustom={null}
          />
          <KogInputText
            id="id-partsCatalogModal-txt-description"
            name="description"
            label={getTranslateByKey('information.description')}
            value={partCatalogDetail?.description}
            InputLabelProps={{ shrink: true }}
            InputProps={{ readOnly: true }}
            errorMessageCustom={null}
          />
          <KogInputText
            id="id-partsCatalogModal-txt-part"
            name="part"
            label={getTranslateByKey('information.part')}
            value={partCatalogDetail?.partName}
            InputLabelProps={{ shrink: true }}
            InputProps={{ readOnly: true }}
            errorMessageCustom={null}
          />
          <KogInputText
            id="id-partsCatalogModal-txt-position"
            name="position"
            label={getTranslateByKey('information.position')}
            value={partCatalogDetail?.position}
            InputLabelProps={{ shrink: true }}
            InputProps={{ readOnly: true }}
            errorMessageCustom={null}
          />

          {partCatalogDetail?.vehicles && (
            <S.ContainerVehicles>
              <ColumnLabel
                label={getTranslateByKey("information.vehicle")}
                content={
                  <S.ListVehicles>
                    {partCatalogDetail?.vehicles.map(vehicle => <p>{vehicle}</p>)}
                  </S.ListVehicles>
                }
              />
            </S.ContainerVehicles>
          )}
        </S.AreaForm>
      </Box>
      <S.FooterButtons>
        <SecondaryButton
          type="button"
          onClick={() => closeModal()}
          id="id-insurerBodyshopTabSettings-button-back">
          {getTranslateByKey('information.back')}
        </SecondaryButton>
      </S.FooterButtons>
    </>
  )

}

export default ModalPartsCatalogDetails